{
  "version": 1,
  "asset_id": "6ce18cdd-8740-4e63-afc1-022c783fe5e4",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/6ce18cdd-8740-4e63-afc1-022c783fe5e4/bypass-revision-downsizing-es-640.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/6ce18cdd-8740-4e63-afc1-022c783fe5e4/bypass-revision-downsizing-es-640.webp",
  "original_filename": "bypass-revision-downsizing-es-640.webp",
  "size": 43204,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:37:30Z"
}
